const FEATURES = [
  {
    icon: "ri-flashlight-line",
    title: "Post in 60 Seconds",
    desc: "Describe your job, set the pay, and hit send. No account setup, no lengthy forms — just fast hiring.",
    color: "text-amber-500",
    bg: "bg-amber-50",
  },
  {
    icon: "ri-radar-line",
    title: "AI-Powered Matching",
    desc: "Our algorithm instantly scans availability, location, skills, and ratings to surface the best candidates.",
    color: "text-emerald-600",
    bg: "bg-emerald-50",
  },
  {
    icon: "ri-shield-check-line",
    title: "Vetted & Rated Workers",
    desc: "Every worker has a verified profile, job history, and star rating — so you hire with total confidence.",
    color: "text-sky-600",
    bg: "bg-sky-50",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Pay Only On Completion",
    desc: "No upfront deposits. A 10–20% platform commission is only charged when the job is successfully done.",
    color: "text-violet-600",
    bg: "bg-violet-50",
  },
];

const STEPS = [
  { step: "01", title: "Post Your Job", desc: "Describe what you need, set urgency and pay rate. Takes under a minute." },
  { step: "02", title: "Get Matched", desc: "AI matches your post to available, qualified workers in your area within minutes." },
  { step: "03", title: "Hire & Get It Done", desc: "Review candidates, confirm the hire, and watch the job get completed — fast." },
];

const TESTIMONIALS = [
  {
    name: "Rachel Kim",
    role: "Property Manager",
    company: "Urban Living Properties",
    quote: "We needed a cleaning crew on 2 hours notice. Gig n' Cash had 4 matched candidates in 8 minutes. Absolutely wild.",
    rating: 5,
    avatar: "https://public.readdy.ai/ai/img_res/67c35f1f28568ecfee8829728e0c5624.jpg",
  },
  {
    name: "Marcus Torres",
    role: "Event Director",
    company: "Premier Events Co.",
    quote: "We staff 30+ events a month through Gig n' Cash. The urgency broadcasting feature is a total game changer.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=professional%20man%20event%20director%20headshot%20clean%20background%20portrait%20confident%20business%20casual%20smiling&width=80&height=80&seq=t2&orientation=squarish",
  },
  {
    name: "Linda Park",
    role: "Operations Manager",
    company: "BuildRight LLC",
    quote: "Construction labor is hard to find fast. Gig n' Cash reduced our idle time by 40% in the first month alone.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=professional%20woman%20operations%20manager%20construction%20industry%20headshot%20clean%20background%20portrait%20corporate&width=80&height=80&seq=t3&orientation=squarish",
  },
];

export default function HireFeatures() {
  return (
    <>
      {/* Steps */}
      <section className="py-16 bg-[#fafafa] border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-2">How It Works for Employers</h2>
            <p className="text-gray-500 text-base">Three steps from job post to job done.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {STEPS.map((s) => (
              <div key={s.step} className="relative text-center">
                <div className="text-5xl font-black text-gray-100 mb-2 select-none">{s.step}</div>
                <h3 className="text-base font-extrabold text-gray-900 mb-2">{s.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-16 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {FEATURES.map((f) => (
              <div key={f.title} className="p-6 rounded-2xl border border-gray-100 bg-[#fafafa]">
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${f.bg} mb-4`}>
                  <i className={`${f.icon} ${f.color} text-lg`} />
                </div>
                <h3 className="font-extrabold text-gray-900 text-sm mb-2">{f.title}</h3>
                <p className="text-xs text-gray-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-[#fafafa]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <h2 className="text-xl font-extrabold text-gray-900 mb-8 text-center">Trusted by Employers Across Industries</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {TESTIMONIALS.map((t) => (
              <div key={t.name} className="bg-white border border-gray-100 rounded-2xl p-6 flex flex-col gap-4">
                <div className="flex gap-0.5">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                  ))}
                </div>
                <p className="text-sm text-gray-700 leading-relaxed italic">&ldquo;{t.quote}&rdquo;</p>
                <div className="flex items-center gap-3 pt-2 border-t border-gray-100">
                  <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover object-top" />
                  <div>
                    <div className="text-xs font-bold text-gray-900">{t.name}</div>
                    <div className="text-xs text-gray-500">{t.role} · {t.company}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
